import { render, staticRenderFns } from "./VEstimatesStatus.vue?vue&type=template&id=70431163&"
import script from "./VEstimatesStatus.vue?vue&type=script&lang=ts&"
export * from "./VEstimatesStatus.vue?vue&type=script&lang=ts&"
import style0 from "./VEstimatesStatus.vue?vue&type=style&index=0&id=70431163&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports